import Dialog, { DialogContent } from 'material-ui/Dialog'
import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import { get } from '../../modules/Api'
import styleSheet from './AllWebChatStyle.style'

class WebChatCreditCardModal extends React.Component {
  state = {
    card_number: '',
    full_name: '',
    expiry_date: '',
    cvc: '',
    ticket_price: '',
    buy_count: '',
  }

  componentDidMount() {
    get('/api/web_chat/account/ticket_info', (response) => {
      const { ticket_price, buy_count } = response.data.attributes
      this.setState({ ticket_price, buy_count })
    })
  }

  onChange(fieldName, value) {
    this.setState({ [fieldName]: value })
  }

  render() {
    const { planChangeModal, sp_charge_type, organization_plan, flag_irregular } = this.props
    const classes = this.props.classes
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={planChangeModal && (sp_charge_type == 1 || (organization_plan && !flag_irregular))}
        onRequestClose={() => this.props.onChange('planChangeModal', !planChangeModal)}
      >
        <DialogContent className={classes.planModalContent}>
          <div
            className={`${classes.circle} ${classes.cardModal_closeBtn}`}
            onClick={() => this.props.onChange('planChangeModal', false)}
          >
            <div>×</div>
          </div>
          <div className={classes.cardModal_title}>
            <p>
              フリーテキストでの看護師相談については
              <br />
              今月の送信可能回数が0回となっています
              <br />
              <br />
              ※botは引き続きご利用いただけます
              <br />
              翌月1日にクーポン期限内であれば所定の回数に戻ります
              <br />
            </p>
          </div>
          <div className={classes.cardModal_btnForm}>
            <button
              className={`btn btn-default ${classes.modal_defBtn}`}
              onClick={() => this.props.onChange('planChangeModal', false)}
            >
              閉じる
            </button>
          </div>
        </DialogContent>
      </Dialog>
    )
  }
}

export default withStyles(styleSheet)(WebChatCreditCardModal)
